
  @for (url of stackedUrls(); track $index) {
    <img [src]="url" class="countdown-bar__team-logo countdown-bar__team-logo--stacked" alt="">
  }
@empty { @if (singleTeam(); as team) {
  <span class="countdown-bar__abbr">{{ teamAbbreviation(team) }}</span>
  <img [src]="team.URI" [alt]="team.name" class="countdown-bar__team-logo">
}}
